import React, {PureComponent} from 'react';
//Components

interface PartPreviewProps{}
export default class PartPreview extends PureComponent<PartPreviewProps> {

  render(){
    return (
      <div>PartPreview</div>
    );
  }
}
